export const isInvalidPostOwnerId = (id) => isNaN(Number(id));
